// about.js
import './bootstrap';

import { createApp } from 'vue';

import QuoteFormLoader from './components/QuoteFormLoader.vue';
import ConsentBanner from './components/ConsentBanner.vue';
import Timeline from './components/Timeline.vue';
import { loadPrimeVue } from '@/utils/loadPrimeVue.js'

const app = createApp({});

// Provide the loader via a global property or a prop wrapper
app.provide('QuoteFormLoader', () => import('./components/QuoteForm.vue'))

app.component('quote-form-loader', QuoteFormLoader);
app.component('consent-banner', ConsentBanner);
app.component('time-line', Timeline);

await loadPrimeVue(app)

app.mount('#app');